var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatisticFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3337 17.0909H5.97003C5.31548 17.0909 4.87912 17.5273 4.87912 18.1818V26.9091C4.87912 27.5636 5.31548 28 5.97003 28H10.3337C10.9882 28 11.4246 27.5636 11.4246 26.9091V18.1818C11.4246 17.5273 10.9882 17.0909 10.3337 17.0909ZM27.7882 12.7273H23.4246C22.77 12.7273 22.3337 13.1636 22.3337 13.8182V26.9091C22.3337 27.5636 22.77 28 23.4246 28H27.7882C28.4428 28 28.8791 27.5636 28.8791 26.9091V13.8182C28.8791 13.1636 28.4428 12.7273 27.7882 12.7273ZM19.0609 4H14.6973C14.0428 4 13.6064 4.43636 13.6064 5.09091V26.9091C13.6064 27.5636 14.0428 28 14.6973 28H19.0609C19.7155 28 20.1518 27.5636 20.1518 26.9091V5.09091C20.1518 4.43636 19.7155 4 19.0609 4Z",
    fill: "#4FD1DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticFilled);
export default __webpack_public_path__ + "static/media/statistic-filled.e32559839a809be23f82dd2852c73635.svg";
export { ForwardRef as ReactComponent };